export default {
    homepage: '/home-page/',
    login: '/'
};
